import PropTypes from 'prop-types';
import { useState } from 'react';
import { isValidationBasedOnType } from '../../utils/common';
import { VALID_CHECKBOX } from '../../utils/constant';

const CheckboxForm = ({ element, handleChange }) => {
  const [showError, setShowError] = useState('');
  const handleCheckBox = (event, val) => {
    let valueArr = [];
    if (element?.userInput) {
      valueArr = element.userInput.split(',');
    }
    const itemIndex = valueArr.indexOf(val);
    if (event.target.checked) {
      if (itemIndex === -1) {
        valueArr.push(val);
      }
    } else {
      if (itemIndex > -1) {
        valueArr.splice(itemIndex, 1);
      }
    }

    const question = { ...element, userInput: valueArr.join(','), eligibleErr: true };
    if (question.isEligibal) {
      let eligibleErr = true;
      const eligVal = question?.eligibleValues?.split(',');
      for (const item in valueArr) {
        if (eligVal?.includes(valueArr[item])) {
          eligibleErr = false;
        }
      }
      question.eligibleErr = eligibleErr;
    }
    if (question.isRequired) {
      if (isValidationBasedOnType(question?.userInput, 'require')) {
        setShowError('');
        question.validationError = false;
      } else {
        setShowError(VALID_CHECKBOX);
        question.validationError = true;
      }
    } else {
      setShowError('');
      question.validationError = false;
    }
    handleChange(event, question);
  };

  return (
    <>
      <div className="d-flex flex-wrap">
        {element?.values?.split(',')?.map((val, index) => {
          return (
            <div className="d-flex align-items-center mb-2 me-3" key={`${element?._id}-${val}-${index}`}>
              <input
                type="checkbox"
                className="form-check-input fs-13 mx-1 check"
                name={element?.question}
                value={val}
                checked={element?.userInput?.split(',')?.includes(val)}
                onChange={(e) => handleCheckBox(e, val)}
              />
              <label className="form-check-label fs-13 answer mx-1">{val}</label>
            </div>
          );
        })}
      </div>
      <span className="text-danger fs-12">{showError !== '' && showError}</span>
    </>
  );
};

CheckboxForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};
export default CheckboxForm;
